export default function Checkmark({w = '32px', h = '32px'}) {
  return <svg width={w} height={h} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#7FC9A0" fillOpacity="0.2"/>
    <path d="M16 24.3529L22.7765 30.1176L32.9412 16.9412" stroke="#0E840B" strokeWidth="3"/>
  </svg>
}